import _get from "lodash/get";
import _forEach from "lodash/forEach";
import _invert from "lodash/invert";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import classnames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export var MARK_TAGS;
(function (MARK_TAGS) {
  MARK_TAGS["strong"] = "bold";
  MARK_TAGS["em"] = "italic";
  MARK_TAGS["u"] = "underline";
  MARK_TAGS["s"] = "strike";
  MARK_TAGS["sup"] = "superscript";
  MARK_TAGS["sub"] = "subscript";
})(MARK_TAGS || (MARK_TAGS = {}));
export function renderMark(mark, value, children) {
  // If the value is falsey, then just return the children.
  if (!value) {
    return children;
  }

  // Determine what HTML tag we should use.
  var tagsForTypes = _invert(MARK_TAGS);
  var tag = tagsForTypes[mark] || 'span';
  var props = {};

  // Wrap the children in this tag.
  return /*#__PURE__*/React.createElement(tag, props, children);
}
export var RichTextLeaf = function RichTextLeaf(_ref) {
  var children = _ref.children,
    leaf = _ref.leaf,
    attributes = _ref.attributes;
  var leafAttributes = attributes || {};
  if (leaf) {
    _forEach(MARK_TAGS, function (mark) {
      children = renderMark(mark, leaf[mark], children);
    });

    // Combine with Slate editor attributes
    leafAttributes = Object.assign({}, attributes, _get(leaf, 'attributes', {}));
    if (leaf.color) {
      var typogClass = "typog--".concat(leaf.color);
      leafAttributes.className = classnames(typogClass, leafAttributes.className);
    }
  }
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({}, leafAttributes), {}, {
    children: children
  }));
};